const state = {
  token: '',
};

const getters = {
  token: (state) => state.token,
};

const mutations = {
  TOKEN: (state, value) => state.token = value,
};

const actions = {
  updateToken: ({commit}, value) => commit('TOKEN', value),
  async handleInviteGuestsByEmail({ rootGetters, dispatch }, [type, emails]) {
    let users = emails.map(e => e = {email: e})
    if(type === 'room') {
      let res = await dispatch('api/nav/inviteGuestsToRoomByEmail', [rootGetters.getSpacePageId, users], {root: true})
      let data = res?.success
      if(!data) dispatch('popups/show/error/custom', 'inviting guests to this Room', {root: true})
      else {
        let successNo = data.filter(u => u.result === 'success')
        let failedNo = data.filter(u => u.result !== 'success')
        dispatch('popups/guest/successInvitingGuestsToRoom', [successNo, failedNo], {root: true})
        dispatch('analytics/inviteGuestToRoomEmail', [emails, successNo, failedNo], {root: true})
      }
      return res
    } else if(type === 'space') {
      let res = await dispatch('api/nav/inviteGuestsToSpaceByEmail', [rootGetters.getCurrentAreaId, users], {root: true})
      let data = res?.success
      if(!data) dispatch('popups/show/error/custom', 'inviting guests to this Space', {root: true})
      else {
        let successNo = data.filter(u => u.result === 'success')
        let failedNo = data.filter(u => u.result !== 'success')
        dispatch('popups/guest/successInvitingGuestsToSpace', [successNo, failedNo], {root: true})
        dispatch('analytics/inviteGuestToSpaceEmail', [emails, successNo, failedNo], {root: true})
      }
      return res
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
